/**
 * Conteúdo do painel ativo (`tab`), usado pelo painel lateral (desktop) e
 * pelos ajustes da folha (celular). A navegação entre painéis fica no trilho
 * (desktop) e na grade de camadas da folha (celular).
 */
import { useUiStore } from '../state/ui';
import { getPanel, getPanels } from './panels';

export function PanelContent() {
  const tab = useUiStore((s) => s.tab);
  const def = getPanel(tab) ?? getPanels()[0];
  if (!def) return null;
  const Panel = def.Panel;
  return (
    <div role="region" aria-label={`Opções: ${def.label}`} className="min-h-0">
      <Panel />
    </div>
  );
}
